export default "__VITE_ASSET__Co79TLXr__"